module.exports = __webpack_public_path__ + "static/media/ring.ccf8d69c.svg";